import { OsmAPIList } from '@/api'

const api = new OsmAPIList();

export default {
  getServiceRequestList({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.getServiceRequestList(params, (json) => {
        switch (json.status) {
          case 200:
            // commit({ type: 'ServiceRequest/setSelections', selections: json.data });
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  getServiceRequestPolicyDetail({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.getServiceRequestPolicyDetails(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  getServiceRequestDetail({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.getServiceRequestDetail(params, (json) => {
        switch (json.status) {
          case 200:
            if (!json.data.workFlowStep) {
              json.data.workFlowStep = 1;
            }
            let nextStep = parseInt(json.data.workFlowStep);

            commit({
              type: 'setNextStep',
              nextStep: (nextStep < 0) ? 0 : nextStep
            })

            commit({
              type: 'setGeneralForm',
              form: {
                ID: json.data.ID,
                comment: json.data.comment,
                receiveTime: json.data.receiveTime,
                linkedEntity: json.data.linkedEntity,
                linkedEntityID: json.data.linkedEntityID,
                creatorName: json.data.agentEnglishName + ' ' + json.data.agentChineseName,
                serviceType: json.data.serviceType,
                version: json.data.version
              }
            })

            commit({
              type: 'setServiceRequestStatus',
              serviceRequestStatus: json.data.serviceRequestStatus
            })

            commit({
              type: 'setTypeForm',
              form: JSON.parse(json.data.parameter)
            })

            resolve(json);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  getServiceRequestTypes({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.getServiceRequestTypes(params, (json) => {
        switch (json.status) {
          case 200:
            // commit({ type: 'ServiceRequest/setSelections', selections: json.data });
            resolve(json.data);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  getFields({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.getServiceRequestFields(params, (json) => {
        switch (json.status) {
          case 200:
            commit({ type: 'setType', body: json.data });

            var typeForm = {}
            typeForm['ID'] = state.selectedType.data.ID
            state.selectedType.list.forEach((item) => {
              typeForm[item.fieldColumn] = state.selectedType.data[item.fieldColumn]
            })

            console.debug('getFields', typeForm);
            commit({
              type: 'setTypeForm',
              form: typeForm
            })
            commit({ type: 'setServiceRequestType', serviceRequestType: params.type });
            resolve(json.data);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  getRiderFields({ state, commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      api.getRiderFields(params, (json) => {
        switch (json.status) {
          case 200:
            commit({ type: 'setType', body: json.data })
            commit({ type: 'setServiceRequestType', serviceRequestType: params.type })
            resolve(json.data);
            break;
          default:
            reject(json);
            break;
        }
      })
    })
  },

  createServiceRequest({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.createServiceRequest(params, (json) => {
        switch (json.status) {
          case 200:
            commit({ type: 'setServiceRequestStatus', serviceRequestStatus: 'PEN' })
            commit({ type: 'setNextStep', nextStep: 1 })
            resolve(json.data);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  editServiceRequest({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.editServiceRequest(params, (json) => {
        switch (json.status) {
          case 200:
            // commit({ type: 'setType', body: json.data });
            resolve(json.data);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  rejectServiceRequest({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.rejectServiceRequest(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json.data);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  },

  approveServiceRequest({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.approveServiceRequest(params, (json) => {
        switch (json.status) {
          case 200:
            resolve(json.data);
            break;
          default:
            reject(json);
            break;
        }
      }, (err) => {
        reject(err);
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/Osm/ServiceRequest/store/actions.js